import { create } from "zustand"

export interface StateTypes {
  enabledSteps: boolean[]
}

export interface ActionTypes {
  setEnabledSteps: (enabledSteps: boolean[]) => void
  updateEnabledSteps: (step: number) => void
}

export const initialState: StateTypes = {
  enabledSteps: [true, false, false, false, false],
}

export type LiabilityInsuranceStoreTypes = StateTypes & ActionTypes

export const useLiabilityInsuranceStore = create<LiabilityInsuranceStoreTypes>(
  (set, get) => ({
    ...initialState,

    setEnabledSteps: (enabledSteps) => set({ enabledSteps }),
    updateEnabledSteps: (step) => {
      const prevSteps = get().enabledSteps
      const newSteps = Array.from({ length: 5 }, (_, i) => {
        if (i === 4) return false
        return prevSteps[i] || i < step
      })
      set({ enabledSteps: newSteps })
    },
  })
)
